<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Ingangsdatum & Einddatum
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul de begin- en eventuele einddatum van een werkrooster in.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Roosteruren en normuren per week
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De normuren per week kun je per werkgever invullen bij de werkgeverinstellingen. In de
                salarisadministratie verwijst "normuren" naar het aantal uren dat binnen een bedrijf werknemers geacht
                wordt te werken in een bepaalde periode, meestal per maand of per jaar. Het is een standaardmaat waarop
                salaris, verlof, overuren en andere arbeidsvoorwaarden worden gebaseerd.
                <div class="space20"><!----></div>

                Voor fulltimers in Nederland is het vaak 36, 38 of 40 uur per week, afhankelijk van de cao of
                arbeidsovereenkomst. Omgerekend naar maanduren: ± 144 tot 173 uur per maand. En omgerekend naar
                jaaruren: ± 1.872 tot 2.080 uur per jaar (bij 52 weken).

                <div class="space20"><!----></div>

                Vul per werknemer het aantal roosteruren in per week.


            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Normuren per week
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                ???
            </div>
        </div>
    </div>
</div>

